import { render, staticRenderFns } from "./GammaKnowledgeBaseWidget.vue?vue&type=template&id=b2e5cf54&scoped=true"
import script from "./GammaKnowledgeBaseWidget.vue?vue&type=script&lang=ts"
export * from "./GammaKnowledgeBaseWidget.vue?vue&type=script&lang=ts"
import style0 from "./GammaKnowledgeBaseWidget.vue?vue&type=style&index=0&id=b2e5cf54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e5cf54",
  null
  
)

export default component.exports